import React, { useEffect, useState } from "react";
import axios from "axios";
import LoginBox from "../components/LoginBox";
import moment from 'moment';
import { FaWhatsapp, FaBed, FaCalendarAlt, FaSignOutAlt, FaSave } from "react-icons/fa";

const AdminPanel = () => {
  const [rooms, setRooms] = useState([]);
  const [priceEdit, setPriceEdit] = useState({});
  const [descEdit, setDescEdit] = useState({});
  const [whatsappNum, setWhatsappNum] = useState(""); // WP Numarası State
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(!localStorage.getItem("token"));
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    if (!showLogin) {
      fetchRooms();
      fetchBookings();
      fetchSettings(); // WP numarasını çek
    }
  }, [showLogin]);

  const fetchRooms = async () => {
    try {
      const res = await axios.get("https://api.pinkhomebalat.com/api/rooms");
      setRooms(res.data);
    } catch (error) {
      console.error("Odalar yüklenirken hata:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSettings = async () => {
    try {
      const res = await axios.get("https://api.pinkhomebalat.com/api/admin/settings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setWhatsappNum(res.data.whatsapp_num || "");
    } catch (err) {
      console.error("Ayarlar çekilemedi");
    }
  };

  const fetchBookings = async () => {
    try {
      const res = await axios.get("https://api.pinkhomebalat.com/api/admin/bookings", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setBookings(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const updateWhatsapp = async () => {
    try {
      await axios.put("https://api.pinkhomebalat.com/api/admin/update-whatsapp", 
        { whatsapp_num: whatsappNum },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      alert("WhatsApp numarası güncellendi!");
    } catch (err) {
      alert("WP güncelleme başarısız.");
    }
  };

  const handleStatus = async (id, status) => {
    try {
      await axios.put(`https://api.pinkhomebalat.com/api/admin/bookings/${id}`, 
        { status }, 
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      fetchBookings();
      alert(`Rezervasyon ${status === 'confirmed' ? 'Onaylandı' : 'Reddedildi'}`);
    } catch (err) {
      alert("İşlem başarısız");
    }
  };

  const updatePrice = async (id) => {
    try {
      const newPrice = priceEdit[id]; // Metin olarak alıyoruz
      await axios.put(`https://api.pinkhomebalat.com/api/rooms/${id}`,
        { price: newPrice },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setRooms(rooms.map(r => r.id === id ? { ...r, price: newPrice } : r));
      alert("Fiyat/Birim güncellendi!");
    } catch (err) {
      alert("Hata: " + (err.response?.data?.error || err.message));
    }
  };

  const updateDescription = async (id) => {
    try {
      const newDesc = descEdit[id];
      await axios.put(`https://api.pinkhomebalat.com/api/rooms/${id}`,
        { description: newDesc },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setRooms(rooms.map(r => r.id === id ? { ...r, description: newDesc } : r));
      alert("Açıklama güncellendi!");
    } catch (err) {
      alert("Hata");
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  if (showLogin) return <div className="fixed inset-0 bg-black flex items-center justify-center z-50"><LoginBox onClose={() => setShowLogin(false)} /></div>;

  return (
    <div className="min-h-screen bg-gray-100 pt-16 pb-12">
      <div className="container mx-auto px-4">
        
        {/* Header */}
        <div className="flex justify-between items-center mb-8 bg-white p-6 rounded-xl shadow-sm">
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
            Admin Kontrol Paneli
          </h1>
          <button onClick={logout} className="bg-red-500 hover:bg-red-600 text-white px-5 py-2 rounded-lg flex items-center gap-2 transition">
            <FaSignOutAlt /> Çıkış
          </button>
        </div>

        {/* WhatsApp Numarası Güncelleme Bölümü */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-8 border-l-8 border-green-500">
          <h2 className="text-xl font-semibold mb-4 text-gray-800 flex items-center gap-2">
            <FaWhatsapp className="text-green-500 text-2xl" /> WhatsApp İletişim Hattı
          </h2>
          <div className="flex flex-col md:flex-row gap-4 items-end">
            <div className="flex-1 w-full">
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Müşterilerin Yazacağı Numara (905xxxxxxxxx)</label>
              <input 
                type="text" 
                value={whatsappNum} 
                onChange={(e) => setWhatsappNum(e.target.value)}
                className="w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-green-500 outline-none text-lg font-mono"
                placeholder="905301112233"
              />
            </div>
            <button onClick={updateWhatsapp} className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-bold flex items-center gap-2 w-full md:w-auto transition shadow-lg shadow-green-200">
              <FaSave /> NUMARAYI KAYDET
            </button>
          </div>
        </div>

        {/* Rezervasyonlar Tablosu */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden mb-8">
          <div className="bg-purple-600 px-6 py-4 flex items-center gap-2 text-white">
            <FaCalendarAlt /> <h2 className="text-xl font-semibold">Rezervasyon İstekleri</h2>
          </div>
          <div className="p-6 overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b text-gray-400 uppercase text-xs tracking-wider">
                  <th className="p-3">Oda</th>
                  <th className="p-3">Müşteri</th>
                  <th className="p-3">Tarih</th>
                  <th className="p-3">Durum</th>
                  <th className="p-3">İşlem</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((b) => (
                  <tr key={b.id} className="border-b hover:bg-gray-50 transition">
                    <td className="p-3 font-medium">{b.room_name}</td>
                    <td className="p-3">
                      <div className="font-bold">{b.customer_name}</div>
                      <div className="text-xs text-gray-500">{b.customer_phone}</div>
                    </td>
                    <td className="p-3 text-sm">
                      {moment(b.check_in).format("DD/MM")} - {moment(b.check_out).format("DD/MM/YYYY")}
                    </td>
                    <td className="p-3">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold text-white ${
                        b.status === 'confirmed' ? 'bg-green-500' : 
                        b.status === 'pending' ? 'bg-yellow-500' : 'bg-red-500'
                      }`}>
                        {b.status === 'pending' ? 'Bekliyor' : b.status === 'confirmed' ? 'Onaylı' : 'Red'}
                      </span>
                    </td>
                    <td className="p-3">
                      <div className="flex gap-2">
                        {b.status === 'pending' && (
                          <>
                            <button onClick={() => handleStatus(b.id, 'confirmed')} className="bg-green-100 text-green-700 hover:bg-green-200 px-3 py-1 rounded text-xs font-bold transition">Onayla</button>
                            <button onClick={() => handleStatus(b.id, 'rejected')} className="bg-red-100 text-red-700 hover:bg-red-200 px-3 py-1 rounded text-xs font-bold transition">Reddet</button>
                          </>
                        )}
                        {b.status === 'confirmed' && (
                          <button onClick={() => window.confirm("İptal edilsin mi?") && handleStatus(b.id, 'rejected')} className="bg-gray-200 text-gray-600 px-3 py-1 rounded text-xs transition">İptal Et</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Oda Güncellemeleri */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="bg-pink-600 px-6 py-4 flex items-center gap-2 text-white">
            <FaBed /> <h2 className="text-xl font-semibold">Oda Bilgilerini Güncelle</h2>
          </div>
          {loading ? (
            <div className="p-10 text-center text-gray-400">Yükleniyor...</div>
          ) : (
            <div className="divide-y divide-gray-100">
              {rooms.map(room => (
                <div key={room.id} className="p-6 grid md:grid-cols-3 gap-6 items-start">
                  <div>
                    <h3 className="text-lg font-bold text-gray-800">{room.name}</h3>
                    <div className="bg-gray-50 p-3 rounded-lg mt-2">
                      <p className="text-sm text-gray-500 italic">Mevcut:</p>
                      <p className="text-blue-600 font-bold">{room.price}</p>
                      <p className="text-xs text-gray-400 mt-1 line-clamp-2">{room.description}</p>
                    </div>
                  </div>

                  {/* Fiyat Girişi (Serbest Metin) */}
                  <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Yeni Fiyat / Birim</label>
                    <input
                      type="text"
                      defaultValue={room.price}
                      onChange={e => setPriceEdit({ ...priceEdit, [room.id]: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                      placeholder="Örn: 40 € veya 1500 TL"
                    />
                    <button onClick={() => updatePrice(room.id)} disabled={!priceEdit[room.id]} className="mt-2 w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg text-sm font-bold transition">Fiyatı Güncelle</button>
                  </div>

                  {/* Açıklama Girişi */}
                  <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Oda Açıklaması</label>
                    <textarea
                      rows="2"
                      defaultValue={room.description}
                      onChange={e => setDescEdit({ ...descEdit, [room.id]: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-pink-500 outline-none text-sm"
                    />
                    <button onClick={() => updateDescription(room.id)} disabled={!descEdit[room.id]} className="mt-2 w-full bg-pink-500 hover:bg-pink-600 text-white py-2 rounded-lg text-sm font-bold transition">Açıklamayı Güncelle</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;